'use client';
import { useEffect, useState } from 'react';
import { PrismicNextImage } from '@prismicio/next';
import type { ImageFieldImage } from '@prismicio/client';

type ImgixParams = Record<string, string | number | boolean | string[] | undefined>;

interface ResponsivePrismicImageProps {
    image: ImageFieldImage & {
        mobile?: ImageFieldImage;
        desktop?: ImageFieldImage;
    };
    className?: string;
    sizes?: string;
    priority?: boolean;
    imgixParams?: ImgixParams;
}

const DEFAULT_IMGIX_PARAMS: ImgixParams = {
    auto: ['compress'],
    fm: 'webp',
    q: 45,
    fit: 'max',
};

const cleanImageUrl = (field: ImageFieldImage | null): ImageFieldImage | null => {
    if (!field?.url) return field;
    try {
        const url = new URL(field.url);
        return {
            ...field,
            url: `${url.origin}${url.pathname}`,
        };
    } catch {
        return field;
    }
};

const ResponsivePrismicImage:React.FC<ResponsivePrismicImageProps>  =({ image, className, sizes = "100vw", priority = false, imgixParams })=> {
    const [selectedImage, setSelectedImage] = useState<ImageFieldImage | null>(null);

    useEffect(() => {
        const update = () => {
            const width = window.innerWidth;
            if (width <= 640 && image.mobile) {
                setSelectedImage(cleanImageUrl(image.mobile));
            } else if (width <= 1024 && image.mobile) {
                setSelectedImage(cleanImageUrl(image.mobile));
            } else {
                setSelectedImage(cleanImageUrl(image));
            }
        };
    
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, [image]);


    if (!selectedImage) return null; // Avoid hydration mismatch

    // console.log(image, selectedImage)
    return (
        <PrismicNextImage
            field={selectedImage}
            className={className}
            fallbackAlt=""
            sizes={sizes}
            priority={priority}
            imgixParams={{ ...DEFAULT_IMGIX_PARAMS, ...(imgixParams || {}) }}
        />
    );
}

export default ResponsivePrismicImage
